import { render, staticRenderFns } from "./SimpleInput.vue?vue&type=template&id=2f1fa5ea&"
import script from "./SimpleInput.vue?vue&type=script&lang=ts&"
export * from "./SimpleInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports